import __var_0__ from '@stdlib/assert/is-ndarray-like';
import __var_1__ from '@stdlib/assert/is-float64array';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isndarrayLike = __var_0__;
var isFloat64Array = __var_1__;


// MAIN //

/**
* Tests if a value is an ndarray-like object whose underlying data type is `float64`.
*
* @param {*} v - value to test
* @returns {boolean} boolean indicating if a value is an ndarray-like object whose underlying data type is `float64`
*
* @example
* var Float64Array = require( '@stdlib/array/float64' );
* var ctor = require( '@stdlib/ndarray/ctor' );
*
* var ndarray = ctor( 'float64', 2 );
* var buffer = new Float64Array( [ 0, 0, 0, 0 ] );
* var arr = ndarray( buffer, [ 2, 2 ], [ 2, 1 ], 0, 'row-major' );
*
* var bool = isFloat64ndarrayLike( arr );
* // returns true
*
* bool = isFloat64ndarrayLike( [] );
* // returns false
*/
function isFloat64ndarrayLike( v ) {
	return ( isndarrayLike( v ) && isFloat64Array( v.data ) );
}


// EXPORTS //
export default isFloat64ndarrayLike;
